export const internationalFormat = 'YYYY-MM-DD';
export const internationalWithTimeFormat = 'YYYY-MM-DD HH:mm:ss';
export const indonesianFormat = 'DD-MM-YYYY';
export const indonesianWithTimeFormat = 'DD-MM-YYYY HH:mm:ss';
export const indonesianMonthFormat = 'MM-YYYY';
export const internationalMonthFormat = 'YYYY-MM';
export const indonesianMonthFullFormat = 'MMMM YYYY';